import { css } from 'styled-components';

const appStyles = css`
  .MuiCollapse-container {
    max-width: calc(100% - 40px) !important;
    width: 600px !important;
  }

  .MuiCollapse-container > div > div > div > div {
    border-radius: 8px !important;
  }

  @media (max-width: 599.95px) {
    .MuiCollapse-container {
      margin: auto !important;
    }
  }

  .react-tel-input .flag-dropdown {
    top: 15px !important;
    bottom: 15px !important;
    background-color: #ffffff !important;
    border: none !important;
    left: 10px;
  }

  .MuiDrawer-root {
    margin: 0 auto !important;
  }

  .MuiBackdrop-root {
    margin: 0 auto !important;
  }

  .MuiPaper-root {
    background-color: ${({ theme }) => theme.background} !important;
  }

  .MuiDrawer-paper {
    width: 80vw !important;
    max-width: 450px !important;
    position: absolute !important;
    padding: 0 !important;
    background-color: ${({ theme }) => theme.surface} !important;
    & .muidivider-root: {
      background-color: ${({ theme }) => theme.surface} !important;
    }
  }

  .MuiDialogContent-root {
    background-color: ${({ theme }) => theme.background} !important;
  }

  .intercom-lightweight-app {
    display: none;
  }
`;

export default appStyles;
